import React from 'react';
import { Section } from './ui/Section';
import { PricingCard } from './PricingCard';
import { CtaFrame } from './ui/CtaFrame';
import { useCountdown } from '../hooks/useCountdown';
import { Clock, AlertTriangle } from 'lucide-react';
import { Eucalyptus } from './botanical/Eucalyptus';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
export function CTA3() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-cream-warm relative overflow-hidden" data-id="element-188">
      <Eucalyptus className="absolute top-10 -left-20 w-80 h-80 text-moss opacity-10 blur-sm" data-id="element-189" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-190">
        <CtaFrame variant="forest" data-id="element-191">
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 md:p-8 border-2 border-honey/40 text-center mb-10 max-w-3xl mx-auto shadow-[0_0_30px_-5px_rgba(212,162,76,0.3)]" data-id="element-192">
            <div className="flex items-center justify-center gap-2 text-honey-light font-bold uppercase tracking-wider mb-4" data-id="element-193">
              <Clock className="w-5 h-5" data-id="element-194" />
              EL PRECIO DE LANZAMIENTO CIERRA EN:
            </div>
            <div className="text-4xl md:text-5xl font-mono font-bold text-honey-light mb-6 drop-shadow-[0_0_15px_rgba(212,162,76,0.5)]" data-id="element-195">
              {hours}{' '}
              <span className="text-2xl md:text-3xl text-sage-mist" data-id="element-196">HS</span> :{' '}
              {minutes}{' '}
              <span className="text-2xl md:text-3xl text-sage-mist" data-id="element-197">MIN</span> :{' '}
              {seconds}{' '}
              <span className="text-2xl md:text-3xl text-sage-mist" data-id="element-198">SEG</span>
            </div>
            <div className="space-y-2 text-sm md:text-base font-medium" data-id="element-199">
              <p className="flex items-center justify-center gap-2 text-cream-warm" data-id="element-200">
                <AlertTriangle className="w-4 h-4 text-honey-light" data-id="element-201" />
                ⚠️ Después sube $10.000 ARS. No vuelve.
              </p>
              <p className="text-honey-light font-bold" data-id="element-202">
                🔴 Más del 60% de los cupos al precio de lanzamiento ya tomados.
              </p>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-cream-warm mb-10" data-id="element-203">
            ELEGÍ TU HOGAR NATURAL
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-204">
            <PricingCard title="HOGAR NATURAL" subtitle="5 Tomos + 5 Bonos" oldPrice="$34.000" price="$17.999" features={['5 tomos digitales completos', '5 bonos incluidos', 'Más de 80 protocolos naturales', 'Acceso inmediato en PDF', 'Para toda la familia']} buttonText="→ QUIERO MI HOGAR NATURAL" href={CHECKOUT_URLS.hogarNatural} data-id="element-205" />
            <PricingCard title="SUPER PACK HOGAR NATURAL" subtitle="5 Tomos + 5 Bonos + 5 Módulos Premium" oldPrice="$58.000" price="$27.999" features={['Todo lo del Hogar Natural', 'Botiquín Natural Listo Para Usar', 'Recetario Maestro de Preparados', 'Hogar Natural para Niños y Familia', '30 Días de Implementación', 'La Biblia del Hogar Natural']} buttonText="→ QUIERO EL SUPER PACK COMPLETO" href={CHECKOUT_URLS.superPack} isPopular data-id="element-206" />
          </div>
        </CtaFrame>
      </div>
    </Section>;
}